require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.assign");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('invariant')) : typeof define === 'function' && define.amd ? define(['invariant'], factory) : global['get-prototype-descriptors'] = factory(global.invariant);
})(this, function (invariant) {
  'use strict';

  invariant = invariant && invariant.hasOwnProperty('default') ? invariant['default'] : invariant;
  var getPrototypeOf = Object.getPrototypeOf,
      assign = Object.assign,
      getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors;
  invariant(getOwnPropertyDescriptors, 'get-prototype-descriptors requires Object.getOwnPropertyDescriptors. See https://github.com/taras/get-prototype-descriptors#compatibility');

  function getPrototypeDescriptors(constructor) {
    var prototype = getPrototypeOf(constructor);

    if (prototype && prototype !== getPrototypeOf(Object)) {
      return assign(getPrototypeDescriptors(prototype), getOwnPropertyDescriptors(constructor.prototype));
    } else {
      return getOwnPropertyDescriptors(constructor.prototype);
    }
  }

  return getPrototypeDescriptors;
});